import axios from "axios";
import { getHttpClientBaseUrl } from "../config/apiConstants";
import { getAdminApiToken } from "../utils/adminApiToken";

const baseURL = getHttpClientBaseUrl();

/**
 * Shared Axios instance for admin + public JSON APIs.
 * - Sends `Authorization: Bearer <token>` when `getAdminApiToken()` is set (unless `skipAuth: true`).
 * - On 401, dispatches a window event for optional logout UI (see AdminLayout).
 */
export const httpClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 45_000,
});

httpClient.interceptors.request.use(
  (config) => {
    const next = { ...config };
    if (next.skipAuth) return next;
    const token = getAdminApiToken();
    if (token) {
      next.headers = next.headers || {};
      next.headers.Authorization = `Bearer ${token}`;
    }
    return next;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const skip =
      error?.config?.skipUnauthorizedEvent === true ||
      error?.config?.url?.includes("/auth/login");
    if (status === 401 && !skip) {
      window.dispatchEvent(new CustomEvent("vh-admin-api-unauthorized"));
    }
    return Promise.reject(error);
  }
);
